import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceBilling from "@/components/admin/admin-workspace-billing";

const AdminWorkspaceBillingPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceBilling workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/billing")({
	component: AdminWorkspaceBillingPage,
});
